<template>
  <v-container fluid class="py-0">
    <v-row justify="center">
      <v-col cols="12" md="10" mx-auto>
        <v-card flat v-if="lAction === 'view'">
          <v-card-title>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                class="pa-0 mt-1"
                append-icon="mdi-account-search-outline"
                :placeholder="$vuetify.breakpoint.smAndUp?'Search user role name, desc, etc...':'Search'"
                single-line
                hide-details
                v-model="search"
                outlined
                clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-download-as
                :headers="roleHead"
                :items="rolesList"
                title="User Roles list"
                ></v-download-as>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="pa-1">
            <v-data-table
            :headers="roleHead"
            :items="rolesList"
            hide-default-footer
            class="elevation-2"
            :search="search"
            :mobile-breakpoint="0"
            sort-by="role_name"
            disable-pagination
            >
            <template slot="item" slot-scope="props">
              <tr @click="prepareUpdate(props.item)">
                <td>{{ props.item.role_name }}</td>
                <td>{{ props.item.role_desc }}</td>
                <td>{{ props.item.tot_users }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <v-container v-if="lAction === 'create' || lAction === 'update'" class="pa-0" grid-list-md fluid full-height>
        <v-form ref="lForm" id="form" @submit.prevent="saveChanges(lAction)">
          <v-card flat>
            <v-card-title class="px-0 py-2">
              {{ handy.startWithUpper(lAction) + ' Role' }}
            </v-card-title>
            <v-card-text class="px-0 py-3">
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="lUserRole.role_name"
                  label="Role Name"
                  :rules="[rules.required]"
                  maxlength="25"
                  hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 class="mt-2">
                  <v-textarea
                  v-model="lUserRole.role_desc"
                  label="Role Description"
                  :rules="[rules.required]"
                  hide-details
                  rows="3"
                  maxlength="200"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12>
                  <v-subheader class="primary--text pa-0">Screen Access</v-subheader>
                </v-flex>
                <v-flex xs12 sm6 max-auto>
                  <v-data-table
                  :headers="accHead"
                  :items="lUserRole.role_screen_access_list"
                  hide-default-footer
                  class="elevation-2"
                  :mobile-breakpoint="0"
                  disable-pagination
                  >
                  <template slot="item" slot-scope="props">
                    <tr>
                      <td v-if="props.item.screen_type === 'm' || props.item.screen_type === 'sm'" colspan="3" :class="props.item.screen_type === 'm' ? 'title grey lighten-3' : 'subtitle-1 font-weight-bold grey lighten-4'">{{ props.item.screen_name }}</td>
                      <td v-else>{{ props.item.screen_name }}</td>
                      <td v-if="props.item.screen_type !== 'm' && props.item.screen_type !== 'sm'"><v-checkbox v-model="props.item.view_access" hide-details class="pb-5"></v-checkbox></td>
                      <td v-if="props.item.screen_type !== 'm' && props.item.screen_type !== 'sm'"><v-checkbox v-model="props.item.edit_access" hide-details class="pb-5"></v-checkbox></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn v-if="lAction === 'update' && (config.IS_EDITED_BY_USER)" :disabled="lUserRole.is_system_role === 1" @click="deleteRole()">delete</v-btn>
            <span v-if="lUserRole.is_system_role" class="caption pl-3">Not possible to delete system roles</span>
            <v-spacer></v-spacer>
            <v-btn @click.stop="lAction = 'view'">Close</v-btn>
            <v-btn type="submit" color="accent" v-if="(config.IS_EDITED_BY_USER)" :disabled="beingSaved">save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-container>

    <v-btn
    :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:15px;':'bottom:15px; right:15px;')"
    dark fab fixed color="accent" v-if="lAction === 'view' && (config.IS_EDITED_BY_USER)"
    @click.native="prepareCreate">
    <v-icon>mdi-plus</v-icon>
  </v-btn>
</v-col>
</v-row>
<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-container>
</template>

<script>
import VDownloadAs from '@/components/VDownloadAs.vue'
import handy from '@/utils/handy'
import config from '@/config/app-cfg'


export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      config: config,
      handy: handy,
      rules: handy.rules,
      search: '',
      beingSaved: false,
      lAction: 'view',
      lUserRole: {},
      rolesList: [],
      roleHead: [
        { text: 'Role Name', value: 'role_name' },
        { text: 'Description', value: 'role_desc' },
        { text: 'Users', value: 'tot_users' }
      ],
      accHead: [
        { text: 'Screen Name', value: 'screen_name', width: '55%', sortable: false },
        { text: 'View', value: 'view_access', sortable: false },
        { text: 'Edit', value: 'edit_access', sortable: false }
      ]
    }
  },
  created () {
    this.loadUserRoles()
  },
  mounted () {

  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    getEmptyRole () {
      return {
        vendor_id: config.VENDOR_ID,
        role_name: '',
        role_screen_access_list: []
      }
    },
    prepareCreate () {
      this.lUserRole = this.getEmptyRole()
      this.loadRoleScreenAccess()
      this.lAction = 'create'
    },
    prepareUpdate (curRole) {
      this.lUserRole = Object.assign({}, curRole) // keep the original object safely before changes
      this.loadRoleScreenAccess()
      this.lAction = 'update'
    },
    deleteRole () {
      this.saveChanges('delete')
    },
    saveChanges (action) {
      if (action === 'delete') {
        if (this.lUserRole.tot_users > 0) {
          this.msg('Unable to delete as there are associated users')
          return
        }
        if (!confirm('Sure, you want to delete role "' + this.lUserRole.role_name + '"?')) {
          return
        }
      } else {
        if (!this.$refs.lForm.validate()) {
          return
        }
      }
      // proceed with changes
      this.beingSaved = true
      this.axios.post(config.API_URL + '/user-role/' + action, this.lUserRole)
      .then(response => {
        // update the object in front end
        this.loadUserRoles()
        this.lAction = 'view'
        this.beingSaved = false
        if (action !== 'delete') {
          this.msg('Saved successfully', 1)
        } else {
          this.msg('Deleted successfully', 1)
        }
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    cancelChanges () {
      this.lAction = 'view'
    },
    loadUserRoles () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUserRolesByVendor/', qry)
      .then(response => {
        this.rolesList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
        this.rolesList = []
      })
    },
    loadRoleScreenAccess () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          role_id: this.lUserRole.role_id
        }
      }
      this.axios.get(config.API_URL + '/getUserRoleScreenAccess/', qry)
      .then(response => {
        this.lUserRole.role_screen_access_list = response.data
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data)
        this.lUserRole.role_screen_access_list = []
      })
    }
  }
}
</script>
